//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import '@streams-drawer/streams-drawer-stream-description/streams-drawer-stream-description';

import { IStream } from '@streams-drawer/model/IStream';
import {
  StreamsDrawerStreamType,
  getRecommendedStreamName,
} from '@streams-drawer/streams-drawer-constants';
import template from './streams-drawer-recommended-header.html';
import './streams-drawer-recommended-header.less';

class StreamsDrawerRecommendedHeader {
  public readonly clientName: string;
  public readonly selectedStreamType: StreamsDrawerStreamType;
  public readonly selectedStream: IStream;
  public tooltipContent: string;
  public autoConfigTbbEnabled: boolean;

  constructor(private SessionVarsService) {}

  public isSummaryStream() {
    return this.selectedStreamType === StreamsDrawerStreamType.SUMMARY;
  }

  public getStreamName() {
    return getRecommendedStreamName(this.selectedStream);
  }
  public $onInit() {
    this.autoConfigTbbEnabled = this.SessionVarsService.isFeatureEnabled(
      'automated_tagged_by_bazaarvoice',
    );
  }
}

angular.module('curalate').component('streamsDrawerRecommendedHeader', {
  bindings: {
    autoConfigTbbEnabled: '<',
    clientName: '<',
    selectedStream: '<',
    selectedStreamType: '<',
    onOpenCurrentApprovalModal: '&',
  },
  controller: ['SessionVarsService', StreamsDrawerRecommendedHeader],
  template,
});
